import {Card} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {toAbsoluteUrl} from '../../../../_metronic/helpers';

const HomePage = (): JSX.Element => {
  const intl = useIntl();

  return (
    <Card>
      <Card.Body className="text-center py-10">
        <img
          src={toAbsoluteUrl('/media/logos/LOGO_CELESTE_Sans_Baseline_Bleu.png')}
          alt="Celeste"
          style={{maxWidth: '220px', height: 'auto'}}
          className="mb-5"
        />
        <h1 className="fs-1 fw-bold mb-3">
          {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.HOME.TITLE'})}
        </h1>
        <p className="text-muted fs-5 mx-auto" style={{maxWidth: '640px'}}>
          {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.HOME.INTRO'})}
        </p>
      </Card.Body>
    </Card>
  );
};

export default HomePage;
